import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setVisible(false);
    };

    const reject = () => {
        localStorage.setItem('cookie_consent', 'rejected');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6" data-testid="cookie-banner">
            <div className="mx-auto max-w-4xl bg-white rounded-xl border shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="flex-1 text-sm text-[hsl(var(--muted-foreground))]">
                    <p>
                        Utilizamos cookies técnicas para el funcionamiento del sitio.
                        Puedes consultar nuestra{' '}
                        <Link to="/politica-cookies" className="text-[var(--brand-blue)] hover:underline font-medium">Política de Cookies</Link>.
                    </p>
                </div>
                <div className="flex gap-2 shrink-0">
                    <Button variant="outline" size="sm" onClick={reject} className="text-xs">
                        Rechazar
                    </Button>
                    <Button size="sm" onClick={accept} className="bg-[var(--brand-navy)] text-white text-xs">
                        Aceptar cookies
                    </Button>
                </div>
            </div>
        </div>
    );
}
